import API from "./api";
import { getSessionId } from "../utils/session";

// ADD TO CART
export const addToCart = async (productId, quantity = 1) => {
  const res = await API.post(
    "/cart/add",
    { product_id: productId, quantity },
    {
      headers: {
        "x-session-id": getSessionId(),
      },
    }
  );

  return res.data;
};

// GET CART
export const getCart = async () => {
  const res = await API.get("/cart", {
    headers: {
      "x-session-id": getSessionId(),
    },
  });

  return res.data;
};

// REMOVE ITEM
export const removeFromCart = async (productId) => {
  const res = await API.delete(`/cart/${productId}`, {
    headers: {
      "x-session-id": getSessionId(),
    },
  });

  return res.data;
};